import React from 'react'
import Table from 'shared/components/Table'
import Popup from 'shared/components/Popup'
import ActionButton from './ActionButton'
import { Label, Radio } from 'semantic-ui-react'
import styled from 'styled-components'

const TopicTable = ({
  dataSource,
  paginationName,
  handleEditAction,
  paginationCurrent,
  paginationPageSize,
  handlePageChange,
  total,
  handleToggleActive,
  allowAdminOrAbove,
  handleDelete,
  updateTopicLoading,
  createTopicLoading,
  topicDataLoading,
}) => {
  const columns = [
    {
      title: 'Topic',
      dataIndex: 'name',
      key: 'name',
      ellipsis: true,
      width: 120,
      render(_, data) {
        return (
          <div className="flex items-center">
            <Popup
              basic
              disabled={!data.description}
              tooltip={<div>{data.description}</div>}
              size="mini"
              wide
              inverted
            >
              <div className="truncate">{data.name}</div>
            </Popup>
          </div>
        )
      },
      sorter(dataA, dataB) {
        const labelA = dataA.name
        const labelB = dataB.name
        return (labelA || '').localeCompare(labelB)
      },
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: 'Count',
      dataIndex: 'answers',
      key: 'answers',
      align: 'right',
      width: 50,
      render(_, data) {
        return <div>{data.answers}</div>
      },
      sorter(dataA, dataB) {
        const valueA = dataA.answers
        const valueB = dataB.answers

        return valueA - valueB
      },
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: 'Group',
      dataIndex: 'groups',
      key: 'groups',
      width: 150,
      render(_, data) {
        return (
          <React.Fragment>
            {data.groups.length > 0 ? (
              <Popup
                basic
                tooltip={<div>{data.groups.map((group) => group.name).join(', ')}</div>}
                size="mini"
                wide
                inverted
              >
                <div className="flex flex-wrap">
                  {data.groups.map((group) => (
                    <Label key={group.key} basic className="!m-0.5 truncate">
                      {group.name}
                    </Label>
                  ))}
                </div>
              </Popup>
            ) : (
              ''
            )}
          </React.Fragment>
        )
      },
    },
    {
      title: 'Source',
      dataIndex: 'source',
      key: 'source',
      width: 80,
      render(_, data) {
        return (
          <div className="flex items-center">
            <Label basic>{data.source === 'predefined' ? 'Default' : 'Custom'}</Label>
          </div>
        )
      },
      sorter(dataA, dataB) {
        const labelA = dataA.source
        const labelB = dataB.source

        return (labelA || '').localeCompare(labelB)
      },
      sortDirections: ['ascend', 'descend'],
    },
    {
      title: 'Visibility',
      dataIndex: 'visibility',
      key: 'visibility',
      width: 80,
      render(_, data) {
        return (
          <div className="flex items-center">
            <Radio
              toggle
              onChange={() => handleToggleActive(data)}
              disabled={!allowAdminOrAbove}
              checked={data.status === 'active'}
            />
          </div>
        )
      },
      sorter(dataA, dataB) {
        const statusOrder = { active: 0, inactive: 1 } // Define order of status
        const statusComparison = statusOrder[dataA.status] - statusOrder[dataB.status]

        if (statusComparison !== 0) {
          return statusComparison // Primary sort by status
        }

        // Secondary sort by name if statuses are equal
        return (dataA.name || '').localeCompare(dataB.name || '')
      },
      sortDirections: ['ascend', 'descend'],
      defaultSortOrder: 'ascend',
    },
    {
      title: '',
      key: 'action',
      align: 'right',
      width: 30,
      render(_, data) {
        if (data.source === 'user_defined' && allowAdminOrAbove) {
          return (
            <ActionButton
              showEdit={data.source === 'user_defined'}
              data={data}
              handleEditAction={handleEditAction}
              showDelete={data.source == 'user_defined'}
              handleDelete={handleDelete}
            />
          )
        }
      },
    },
  ]

  return (
    <div>
      <AntdTopicTable
        variant="indexPage"
        clickable={false}
        dataSource={dataSource}
        className="topic-table"
        loading={updateTopicLoading || createTopicLoading || topicDataLoading}
        columns={columns}
        pagination={
          total > 50
            ? {
                current: paginationCurrent,
                pageSize: paginationPageSize,
                total: total,
                showSizeChanger: true,
                pageSizeOptions: ['50', '100', '500'],
                onChange: (page, pageSize) => handlePageChange(page, pageSize, paginationName),
                onShowSizeChange: (current, size) =>
                  handlePageChange(current, size, paginationName),
              }
            : false
        }
      />
    </div>
  )
}

export default TopicTable

const AntdTopicTable = styled(Table)`
  &.topic-table .ant-table {
    position: relative;
    z-index: 2;
  }

  &.topic-table .ant-table-pagination.ant-pagination {
    display: block;
  }
`



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/pages/Admin/Topics/TopicTable.js